<template>
  <div id="company">
    <div class="company-top">
      <div class="wrap">
        <div class="company-main">
          <div class="company-logo-box">
            <img :src="ClientDetail.logo" class="company-logo" alt="" />
          </div>
          <div class="company-info">
            <p class="company-name">{{ ClientDetail.clientName }}</p>
            <p class="company-desc">
              {{ ClientDetail.companyScaleIdStr }} |
              {{ ClientDetail.industryStr }} |
              {{ ClientDetail.companyNatureIdStr }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <main class="wrap main">
      <article class="article">
        <ul class="tab-wrap">
          <li
            class="tab-tit"
            @click="tabChange(0)"
            :class="{ tabcur: tabNum == 0 }"
          >
            公司详情
          </li>
          <li
            class="tab-tit"
            @click="tabChange(1)"
            :class="{ tabcur: tabNum == 1 }"
          >
            在招职位（{{ ClientDetail.jobCount }}）
          </li>
        </ul>
        <p class="company-detail" v-show="tabNum == 0">
          {{ ClientDetail.description }}
        </p>
        <div class="job-contair">
          <p class="main-tit">在招职位</p>
          <ul class="job-list">
            <li
              class="job-item-company"
              v-for="(item, index) in ClientJobList"
              :key="index"
            >
              <div class="job-l" @click="goJob(item.jobId, item.clientId)">
                <p class="jobnamestr-wrap">
                  <span class="blue jobnamestr">{{ item.jobName }}</span>
                  <span class="blue">[{{ item.areaCodeStr }}]</span
                  ><span class="result-date">{{ item.createDateStr }}发布</span>
                </p>
                <div class="result-money-wrap">
                  <span class="result-money">{{ item.salaryAreaStr }}</span>
                  <ul class="result-money-list">
                    <li>
                      <span class="division">|</span
                      >{{ item.educationLevelIdStr }}
                    </li>
                  </ul>
                </div>
              </div>
              <div class="job-r">
                <div
                  class="apply-btn"
                  :class="{ applyNoclick: item.isSendResume == 1 }"
                  @click="
                    openApply(
                      item.isSendResume,
                      item.jobId,
                      item.clientId,
                      index
                    )
                  "
                >
                  {{ item.isSendResume == 1 ? "已投递" : "立即申请" }}
                </div>
              </div>
            </li>
          </ul>
          <div class="fenye">
            <a-pagination
              v-if="hasData"
              v-model="current"
              :total="ClientJobListTotal"
              :page-size="pageSize"
              @change="onChange"
              show-less-items
            />
          </div>
        </div>

        <div class="fengcai" v-show="tabNum == 0">
          <p class="main-tit">企业风采</p>
          <div v-if="ClientPhoto.length > 0">
            <div class="img-list">
              <div
                class="img-wrap"
                :style="{ transform: `translateX(-${transX * 212}px)` }"
              >
                <img
                  :src="item"
                  class="company-img"
                  alt=""
                  v-for="(item, index) in ClientPhoto"
                  :key="index"
                />
              </div>
            </div>
            <div class="img-btn-wrap" v-if="isPhotoFenye">
              <a-button
                type="primary"
                class="img-btn-left"
                @click="transLeft(transX)"
                ><a-icon type="left"
              /></a-button>
              <a-button
                type="primary"
                class="img-btn-right"
                @click="transRight(transX)"
                ><a-icon type="right" />
              </a-button>
            </div>
          </div>
          <div v-else>
            <div id="null">
              <img
                src="@/assets/img/null.png"
                class="search-null-logo"
                alt=""
              />
              <p class="search-null-tit">暂无数据</p>
            </div>
          </div>
        </div>
      </article>
      <aside class="aside">
        <Map
          v-if="hasMap"
          :markerPoint="markerPoint"
          :address="ClientDetail.address"
        ></Map>
      </aside>
    </main>
    <Apply
      :isSendResume="isCompanySend"
      :isShow="isShow"
      @closeWin="closeWin"
      @isSend="isSend"
      :clientId="clientId"
      :jobId="jobIdThis"
    ></Apply>
  </div>
</template>
<script>
import Map from "@/components/Map.vue";
import Apply from "@/components/Apply.vue";
import {
  getClientDetail,
  getClientJobList,
  getClientPhoto,
} from "@/api/company.js";

export default {
  components: {
    Map,
    Apply,
  },
  data() {
    return {
      hasData: false,
      hasDataNum: 3,
      ClientDetail: {},
      ClientJobList: [],
      ClientPhoto: [],
      markerPoint: { lng: 116.4, lat: 39.9 },
      isPhone: false,
      hasMap: false,
      current: 1,
      userInfo: {
        name: "",
        phone: "",
      },
      tabNum: 0,
      tabData: [
        {
          id: 0,
          tit: "公司详情",
        },
        {
          id: 1,
          tit: "在招职位（30）",
        },
      ],
      ClientJobListTotal: 0,
      ClientJobListPage: 0,
      ClientJobListEnd: 0,
      pageSize: 3,
      isCompanySend: 0,
      isShow: false,
      clientId: 0,
      jobIdThis: 0,
      itemId: 0,
      isPhotoFenye: false,
      transX: 0,
      pageNumber: 0,
    };
  },
  created() {
    this.clientId = this.$route.query.id;
    this.getClient(this.clientId);
    this.getClientJob(this.clientId, 1, 3);
    this.getPhoto(this.clientId);
  },
  methods: {
    // 企业详情
    getClient(clientId) {
      let data = {
        clientId: clientId,
      };
      getClientDetail(data)
        .then((res) => {
          if (res.success) {
            this.ClientDetail = res.data;
            this.markerPoint.lng = res.data.longitude;
            this.markerPoint.lat = res.data.latitude;
            this.hasMap = true;
          }
        })
        .catch((rej) => {
          console.log(rej);
        });
    },
    // 企业在招职位
    getClientJob(clientId, pageIndex, pageSize) {
      let data = {
        clientId: clientId,
        pageIndex: pageIndex,
        pageSize: pageSize,
      };
      getClientJobList(data)
        .then((res) => {
          if (res.success) {
            this.ClientJobList = res.data;
            this.ClientJobListTotal = res.totalCount;
            if (this.ClientJobListTotal > this.hasDataNum) {
              this.hasData = true;
            } else {
              this.hasData = false;
            }
          }
        })
        .catch((rej) => {
          console.log(rej);
        });
    },
    // 获取企业风采
    getPhoto(clientId) {
      let data = {
        clientId: clientId,
      };
      getClientPhoto(data)
        .then((res) => {
          if (res.success) {
            this.ClientPhoto = res.data;
            if (res.data.length > 4) {
              this.isPhotoFenye = true;
            }
          }
        })
        .catch((rej) => {
          console.log(rej);
        });
    },
    tabChange(id) {
      this.tabNum = id;

      if (id == 0) {
        this.pageSize = 3;
        this.pageNumber = 1;
        this.hasDataNum = 3;
        this.getClientJob(this.clientId, 1, this.pageSize);
      } else {
        this.pageSize = 6;
        this.hasDataNum = 6;
        this.pageNumber = 1;
        this.getClientJob(this.clientId, 1, this.pageSize);
      }
    },
    onChange(pageNumber) {
      this.pageNumber = pageNumber;
      this.getClientJob(this.clientId, this.pageNumber, this.pageSize);
    },
    closeWin(message) {
      this.isShow = false;
      // 判断现在的tabnum,从而知道加载3或者6
      // 判断现在的pageNumber，从而知道数据在那一页
      if (message[0]) {
        if (this.tabNum == 0) {
          this.pageSize = 3;
          this.hasDataNum = 3;
          this.getClientJob(this.clientId, this.pageNumber, this.pageSize);
        } else {
          this.pageSize = 6;
          this.hasDataNum = 6;
          this.getClientJob(this.clientId, this.pageNumber, this.pageSize);
        }
      }
    },
    isSend() {
      this.isCompanySend = 1;
      this.ClientJobList[this.itemId].isSendResume = 1;
    },
    openApply(isCompanySend, jobIdThis, clientId, index) {
      this.isShow = true;
      this.isCompanySend = isCompanySend;
      this.jobIdThis = jobIdThis;
      this.clientId = clientId;
      this.itemId = index;
    },
    goJob(id, clientId) {
      this.$router.push({
        path: "/job",
        query: { id: id, clientId: clientId },
      });
    },
    transLeft() {
      if (this.transX != 0) {
        this.transX--;
      }
    },
    transRight() {
      let end = this.ClientPhoto.length - 4;
      if (this.transX != end) {
        this.transX++;
      }
    },
  },
};
</script>
<style scoped>
.job-contair {
  margin-top: 22px;
}
#company {
  padding-top: 64px;
}
.wrap {
  width: 1200px;
  margin: 0 auto;
}
.apply-wrap {
  width: 500px;
  margin: 100px 0;
}
.get-code {
  padding: 10px;
  border: 1px solid;
}
.canAct {
  background: blue;
  border-color: blue;
  color: #fff;
}
.company-top {
  padding: 60px 0;
  background: url("./../../assets/img/company_bg.png") center no-repeat;
}
.main {
  display: flex;
  justify-content: space-between;
  padding-top: 35px;
  background: #fff;
}
.article {
  flex: 1;
  border-right: 1px solid #eee;
  padding-bottom: 40px;
}
.aside {
  flex: 0 0 310px;
  margin-left: 27px;
  padding-bottom: 40px;
}
.company-info {
  padding: 8px 0;
}
.company-name {
  font-size: 28px;
  color: #ffffff;
  line-height: 40px;
  margin-bottom: 15px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.company-desc {
  color: #ffffff;
  line-height: 20px;
}
.company-logo-box {
  width: 100px;
  height: 100px;
  flex: 0 0 100px;
  background: #fff;
  border-radius: 7px;
  margin-right: 24px;
}
.company-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.company-main {
  display: flex;
}
.main-tit {
  position: relative;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  line-height: 22px;
  padding-bottom: 13px;
}
.main-tit::after {
  position: absolute;
  content: "";
  bottom: 0;
  left: 0;
  width: 30px;
  height: 2px;
  background: #3b87ff;
}
.result-money-wrap,
.result-money-list {
  display: flex;
}
.result-money-wrap {
  margin-top: 16px;
}
.result-money {
  color: #ff6600;
  font-size: 16px;
}
.division {
  padding: 0 13px;
  color: #dddddd;
}
.job-item-company {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px dashed #eeeeee;
  padding: 20px 20px 20px 0;
}
.job-item-company:hover .blue {
  color: #3b87ff;
}
.apply-btn {
  width: 94px;
  height: 30px;
  border-radius: 2px;
  border: 1px solid #3b87ff;
  color: #3b87ff;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}
.fenye {
  text-align: right;
  margin: 20px 0 40px;
  padding-right: 24px;
}
.company-detail {
  line-height: 24px;
  margin: 21px 23px 27px 0;
}
.tab-wrap {
  display: flex;
  border-bottom: 1px solid #eee;
}
.tab-tit {
  margin-right: 32px;
  padding-bottom: 14px;
  font-size: 16px;
  line-height: 22px;
  cursor: pointer;
}
.tabcur {
  position: relative;
  color: #3b87ff;
}
.job-l {
  cursor: pointer;
}
.jobnamestr-wrap {
  display: flex;
  align-items: center;
}
.job-l .jobnamestr {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 500px;
}
.tabcur::after {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  content: "";
  height: 2px;
  background: #3b87ff;
}
.img-list {
  margin-top: 20px;
  overflow: hidden;
  margin-right: 25px;
}
.img-wrap {
  display: flex;
}
.company-img {
  flex: 0 0 200px;
  width: 200px;
  height: 150px;
  object-fit: cover;
  border-right: 4px;
  margin-right: 12px;
  border-radius: 8px;
}
.blue {
  font-size: 16px;
  padding-right: 7px;
}
.result-date {
  color: #999;
}
#company {
  background: #fff;
}
.img-btn-wrap {
  margin-top: 22px;
  text-align: right;
  margin-right: 25px;
}
.img-btn-left {
  margin-right: 12px;
}
.ant-btn-primary {
  background: #fff;
  border: 1px solid #dddddd;
  box-shadow: none;
}
.anticon {
  color: #999;
}
#null {
  padding: 20px 0 0;
  text-align: center;
}
.search-null-logo {
  width: 80px;
  height: 80px;
  margin-bottom: 14px;
}
.applyNoclick {
  border: 1px solid #ddd;
  color: #999999;
  cursor: no-drop;
}
</style>
